var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawAddFiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.021,
    height: 114.001,
    viewBox: "0 0 127.021 114.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_add_files_re_v09g",
    transform: "translate(-0.006 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87423",
    "data-name": "Path 87423",
    d: "M274.035,99.313l-4.133,1.066-50.92,13.131-4.133,1.066a7.825,7.825,0,0,0-5.617,9.521l17.922,69.5a7.825,7.825,0,0,0,9.521,5.617l.011,0,59.165-15.258.011,0a7.825,7.825,0,0,0,5.617-9.521l-17.922-69.5A7.825,7.825,0,0,0,274.035,99.313Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87424",
    "data-name": "Path 87424",
    d: "M286.2,113.1l-4.9,1.262-49.4,12.738-4.9,1.262a5.573,5.573,0,0,0-4,6.78l17.922,69.5a5.573,5.573,0,0,0,6.78,4l.011,0,59.165-15.258.011,0a5.573,5.573,0,0,0,4-6.78l-17.922-69.5A5.573,5.573,0,0,0,286.2,113.1Z",
    transform: "translate(-220.581 -110.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87425",
    "data-name": "Path 87425",
    d: "M427.457,239.349l-29.93,7.718a1.3,1.3,0,0,1-.65-2.521l29.93-7.718a1.3,1.3,0,0,1,.65,2.521Z",
    transform: "translate(-365.534 -214.412)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87426",
    "data-name": "Path 87426",
    d: "M439.41,257.285l-35.13,9.059a1.3,1.3,0,0,1-.65-2.521l35.13-9.059a1.3,1.3,0,1,1,.65,2.521Z",
    transform: "translate(-371.191 -229.435)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87427",
    "data-name": "Path 87427",
    d: "M457.725,356.723l-29.93,7.718a1.3,1.3,0,0,1-.65-2.521l29.93-7.718a1.3,1.3,0,1,1,.65,2.521Z",
    transform: "translate(-390.886 -312.721)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87428",
    "data-name": "Path 87428",
    d: "M469.679,374.659l-35.13,9.059a1.3,1.3,0,1,1-.65-2.521l35.13-9.059a1.3,1.3,0,0,1,.65,2.521Z",
    transform: "translate(-396.543 -327.744)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87429",
    "data-name": "Path 87429",
    d: "M487.994,474.1l-29.93,7.718a1.3,1.3,0,0,1-.65-2.521l29.93-7.718a1.3,1.3,0,1,1,.65,2.521Z",
    transform: "translate(-416.238 -411.031)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87430",
    "data-name": "Path 87430",
    d: "M499.947,492.032l-35.13,9.059a1.3,1.3,0,0,1-.65-2.521l35.13-9.059a1.3,1.3,0,0,1,.65,2.521Z",
    transform: "translate(-421.895 -426.053)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87431",
    "data-name": "Path 87431",
    d: "M303.278,293.854l-10.592,2.731a.625.625,0,0,1-.76-.449l-2.431-9.428a.625.625,0,0,1,.449-.76l10.592-2.731a.625.625,0,0,1,.76.449l2.431,9.428A.625.625,0,0,1,303.278,293.854Z",
    transform: "translate(-276.395 -253.284)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87432",
    "data-name": "Path 87432",
    d: "M333.546,411.227l-10.592,2.731a.625.625,0,0,1-.76-.448l-2.431-9.428a.625.625,0,0,1,.449-.76L330.8,400.59a.625.625,0,0,1,.76.449l2.431,9.428A.625.625,0,0,1,333.546,411.227Z",
    transform: "translate(-301.747 -351.593)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87433",
    "data-name": "Path 87433",
    d: "M363.815,528.6l-10.592,2.732a.625.625,0,0,1-.76-.448l-2.431-9.428a.625.625,0,0,1,.449-.76l10.592-2.732a.625.625,0,0,1,.76.449l2.431,9.428A.625.625,0,0,1,363.815,528.6Z",
    transform: "translate(-327.099 -449.902)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87434",
    "data-name": "Path 87434",
    d: "M508.133,209.052H447.01a7.825,7.825,0,0,0-7.817,7.817v71.771a7.825,7.825,0,0,0,7.817,7.817h61.123a7.825,7.825,0,0,0,7.817-7.817V216.868A7.825,7.825,0,0,0,508.133,209.052Z",
    transform: "translate(-401.796 -191.182)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87435",
    "data-name": "Path 87435",
    d: "M519.737,222.906H458.614a5.573,5.573,0,0,0-5.566,5.566v71.771a5.573,5.573,0,0,0,5.566,5.566h61.123a5.573,5.573,0,0,0,5.566-5.566V228.472A5.573,5.573,0,0,0,519.737,222.906Z",
    transform: "translate(-413.4 -202.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87446",
    "data-name": "Path 87446",
    d: "M14.269,0A14.269,14.269,0,1,1,0,14.269,14.269,14.269,0,0,1,14.269,0Z",
    transform: "translate(98.489 85.469)",
    fill: "#8abb2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87436",
    "data-name": "Path 87436",
    d: "M861.752,664.919h-3.857v-3.857a1.446,1.446,0,0,0-2.893,0v3.857h-3.857a1.446,1.446,0,1,0,0,2.893H855v3.857a1.446,1.446,0,0,0,2.893,0v-3.857h3.857a1.446,1.446,0,0,0,0-2.893Z",
    transform: "translate(-743.69 -566.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87437",
    "data-name": "Path 87437",
    d: "M640.9,452.291H609.987a1.3,1.3,0,0,1,0-2.6H640.9a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-543.758 -392.732)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87438",
    "data-name": "Path 87438",
    d: "M646.266,479.338H609.987a1.3,1.3,0,1,1,0-2.6h36.279a1.3,1.3,0,0,1,0,2.6Z",
    transform: "translate(-543.758 -415.387)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87439",
    "data-name": "Path 87439",
    d: "M640.9,573.5H609.987a1.3,1.3,0,1,1,0-2.6H640.9a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-543.758 -494.258)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87440",
    "data-name": "Path 87440",
    d: "M646.266,600.552H609.987a1.3,1.3,0,1,1,0-2.6h36.279a1.3,1.3,0,0,1,0,2.6Z",
    transform: "translate(-543.758 -516.912)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87441",
    "data-name": "Path 87441",
    d: "M514.444,448.394H503.506a.625.625,0,0,1-.624-.624v-9.737a.625.625,0,0,1,.624-.624h10.939a.625.625,0,0,1,.624.624v9.737A.625.625,0,0,1,514.444,448.394Z",
    transform: "translate(-455.14 -382.448)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87442",
    "data-name": "Path 87442",
    d: "M514.444,569.607H503.506a.625.625,0,0,1-.624-.624v-9.737a.625.625,0,0,1,.624-.624h10.939a.625.625,0,0,1,.624.624v9.737A.625.625,0,0,1,514.444,569.607Z",
    transform: "translate(-455.14 -483.974)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87443",
    "data-name": "Path 87443",
    d: "M682.986,317.356H660.2a1.3,1.3,0,1,1,0-2.6h22.788a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-585.814 -279.714)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87444",
    "data-name": "Path 87444",
    d: "M688.356,344.4H660.2a1.3,1.3,0,1,1,0-2.6h28.158a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-585.814 -302.369)",
    fill: "#cce5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87445",
    "data-name": "Path 87445",
    d: "M524.3,299.619H503.295a.625.625,0,0,1-.624-.624V282.6a.625.625,0,0,1,.624-.624H524.3a.625.625,0,0,1,.624.624v16.4A.625.625,0,0,1,524.3,299.619Z",
    transform: "translate(-454.963 -252.26)",
    fill: "#cce5e3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAddFiles);
export default __webpack_public_path__ + "static/media/undraw_add_files.80c460533a2405991f677376c1e1d741.svg";
export { ForwardRef as ReactComponent };